"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var URI = require("urijs");
var BASE_PATH = '';
function set(path) {
    BASE_PATH = path;
}
exports.set = set;
function compose() {
    var segments = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        segments[_i] = arguments[_i];
    }
    var base = new URI(BASE_PATH);
    if (segments.length > 0) {
        return URI.joinPaths.apply(URI, [base].concat(segments));
    }
    else {
        return base;
    }
}
exports.compose = compose;
